import {lazy, FC, Suspense} from 'react'
import {Routes, Route, Navigate, useLocation} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from 'app/pages/dashboard/DashboardWrapper'
import {CompanyPage} from 'app/pages/Company/CompanyPage'
import {ScheduleList} from 'app/pages/Schedules/ScheduleList'
import {CreditList} from 'app/pages/Credit/CreditList'
import {Credit} from 'app/pages/Credit/Credit'
import {CreditPurchaseList} from 'app/pages/CreditPurchase/CreditPurchaseList'
import {CreditPurchase} from 'app/pages/CreditPurchase/CreditPurchase'
import {Schedule} from 'app/pages/Schedules/Schedule'
import LoginPage from 'app/pages/Auth/LoginPage'
import VerifyPhone from 'app/pages/Auth/VerifyPhone'
import CompleteProfile from 'app/pages/Auth/CompleteProfile'
import ListCreditCards from 'app/pages/CreditCard/ListCreditCards'
import Profile from 'app/pages/Profile'
import {LandingPage} from 'app/pages/Site/LandingPage'
import {MenuTestPage} from 'app/pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from 'app/pages/layout-builder/BuilderPageWrapper'
import { Error404 } from 'app/modules/errors/components/Error404'
import { DayUseList } from 'app/pages/DayUse/DayUseList'
import { DayUse } from 'app/pages/DayUse/DayUse'
import { SignatureList } from 'app/pages/Signatures/SignatureList'
import { Signature } from 'app/pages/Signatures/Signature'
import { ContractList } from 'app/pages/Contracts/ContractList'
import { Contract } from 'app/pages/Contracts/Contract'
import { Invoice } from 'app/pages/Invoices/Invoice'
import { HomePage } from 'app/pages/Home/HomePage'
import { RequestLocationPage } from 'app/pages/RequestLocation/RequestLocationPage'
import LoginWithPhone from 'app/pages/Auth/LoginWithPhone'
import { RootRoute } from './RootRoute'
import { UnidadeRoute } from './UnidadeRoute'
import { LessonPage } from 'app/pages/Lessons/LessonPage'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  const location :any = useLocation();

  const login = location.state?.login;
  const verifyPhoneUrl = location.state?.verifyPhoneUrl;
  const completeProfile = location.state?.completeProfile;
  const creditCards = location.state?.creditCards;
  const profile = location.state?.profile;

  // let HashRoute = ({ component: Component, path, ...routeProps } :any) => (
  //   <Route
  //     {...routeProps}
  //     element={({ location, ...props }) =>
  //       location.hash === path && <Component {...props} />
  //     }
  //   />
  // )

  return (<>
    <Routes location={(login || verifyPhoneUrl || completeProfile || creditCards || profile) || location}>

      <Route element={<MasterLayout />}>
        <Route path='/'element={<RootRoute />} />
        <Route path='/unidade/:slug/*'element={<UnidadeRoute />} />
        <Route path='/home'element={<HomePage />} />
        <Route path='/request-location'element={<RequestLocationPage />} />
        <Route path='/locacao-de-quadras'element={<CompanyPage />} />
        <Route path='/pacotes-de-aulas'element={<CompanyPage />} />
        <Route path='/pacotes-de-creditos'element={<CompanyPage />} />
        <Route path='/day-use'element={<CompanyPage />} />
        <Route path='/clubinho'element={<CompanyPage />} />
        <Route path='/aulas'element={<CompanyPage />} />
        <Route path='/aulas/:id'element={<LessonPage />} />

        <Route path='/compras/locacao-de-quadra'element={<ScheduleList />} />
        <Route path='/compras/locacao-de-quadra/:id'element={<Schedule />} />

        <Route path='/compras/pacotes-de-creditos'element={<CreditPurchaseList />} />
        <Route path='/compras/pacotes-de-creditos/:id'element={<CreditPurchase />} />

        <Route path='/compras/creditos'element={<CreditList />} />
        <Route path='/compras/creditos/:id'element={<Credit />} />

        <Route path='/compras/day-use'element={<DayUseList />} />
        <Route path='/compras/day-use/:id'element={<DayUse />} />

        <Route path='/assinaturas/clubinho'element={<SignatureList />} />
        <Route path='/assinaturas/clubinho/:id'element={<Signature />} />

        <Route
          path='/assinaturas/aulas-mensal'
          element={<ContractList modality='class' type='recurrence' basePath='/assinaturas/aulas-mensal' title='Aulas mensal' />}
        />
        <Route
          path='/assinaturas/aulas-mensal/:id'
          element={<Contract basePath='/assinaturas/aulas-mensal' />}
        />

        <Route
          path='/assinaturas/locacao-de-quadra'
          element={<ContractList modality='reservation' type='recurrence' basePath='/assinaturas/locacao-de-quadra' title='Locação de quadra' />}
        />
        <Route
          path='/assinaturas/locacao-de-quadra/:id'
          element={<Contract basePath='/assinaturas/locacao-de-quadra' />}
        />

        <Route path='/faturas/:id'element={<Invoice />} />
      </Route>

      <Route element={<MasterLayout />}>
        <Route path='*' element={<Error404 />} />
      </Route>
    </Routes>

    {/* {login && <LoginPage
      isOpen={true}
      onClosed={() => console.log('onClosed')}
      onLogin={() => console.log('onLogin')}
    />} */}

    {login && <LoginWithPhone
      isOpen={true}
      onClosed={() => console.log('onClosed')}
      onLogin={() => console.log('onLogin')}
    />}

    {verifyPhoneUrl && <VerifyPhone
      isOpen={true}
    />}

    {completeProfile && <CompleteProfile
      isOpen={true}
      onClosed={() => console.log('onClosed')}
      onCompleted={() => console.log('onCompleted')}
    />}

    {creditCards && <ListCreditCards
      isOpen={true}
    />}

    {profile && <Profile
      isOpen={true}
    />}
  </>)
}

// const SuspensedView: FC<WithChildren> = ({children}) => {
//   const baseColor = getCSSVariableValue('--kt-primary')
//   TopBarProgress.config({
//     barColors: {
//       '0': baseColor,
//     },
//     barThickness: 1,
//     shadowBlur: 5,
//   })
//   return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
// }

export {PrivateRoutes}
